import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PaginationContext } from "src/app/shared/object/pagination_context.model";
import { ToastService } from "ng-uikit-pro-standard";
import { FileDownloadService } from "src/app/shared/services/file-download.service";
import { FormValidatorsService } from "src/app/shared/services/form-validators.service";
import { RutService } from "src/app/shared/services/rut.service";
import { MessageRendererService } from "src/app/services/message-renderer.service";
import { ConsoleService } from "src/app/shared/services/console.service";
import { SecurityService } from "src/app/shared/services/security.service";
import * as _ from "lodash";
import { TipoNCNDService } from "src/app/services/tipo-ncnd.service";
import { UnidadNegocioService } from "src/app/services/unidad-negocio.service";
import { MotivoDevolucionService } from "src/app/services/motivo-devolucion.service";
import { DatesService } from "src/app/shared/services/dates.service";
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ModalSeleccionarVendedorComponent } from "src/app/views/shared/modal-seleccionar-vendedor/modal-seleccionar-vendedor.component";

@Component({
  selector: 'app-reporte-nc',
  templateUrl: './reporte-nc.component.html',
  styleUrls: ['./reporte-nc.component.scss'],
  providers: [SecurityService]
})
export class ReporteNcComponent implements OnInit {

  //Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  @ViewChild(ModalSeleccionarVendedorComponent, { static: true }) modalSeleccionarVendedor: ModalSeleccionarVendedorComponent


    // Form
    formHeader: FormGroup

  // Contants
  readonly RB_TIPO_VENDEDOR: String = "_RB_TIPO_VENDEDOR_"
  readonly RB_TIPO_CLIENTE: String = "_RB_TIPO_CLIENTE_"

  // Data & tmp
  private rutEmpresa: number;
  private sucursalCodigo: number;

  listaMovimientosAll: Array<any> = null;
  listaMovimientos: Array<any> = null;
  private currentPayload: any = null

  paginationContext: PaginationContext = new PaginationContext();

  optionsTipoNota: Array<any> = [];
  optionsMotivoDev: Array<any> = [];
  optionsUnidNegocio: Array<any> = [];

  //Seleccion cliente
  clientesSeleccionados: any = null

  //Seleccion cliente
  VendedorSeleccionado: any = null

    // Utils
    private log: any
    rutVendedor: string;
    loading: boolean = false
    TotalNC: number = 0;
    Totalmonto: number = 0;

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService,
    public rutService: RutService,
    private tipoNCNDService: TipoNCNDService,
    private unidadNegocioService: UnidadNegocioService,
    private motivoDevolucionService: MotivoDevolucionService,
    private datesService: DatesService

  ) {
    this.log = this.clog.log('REP. NOTA CRÉDITO')
   }

  ngOnInit() {

    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());

    this.paginationContext.RecordsByPage = 10

    this.loadComboTipoNotaCredito();
    this.loadMotivoDevolucionGeneral();
    this.loadUnidadNegocio();
    this.createForm();

  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()

    this.formHeader = this.fb.group({
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      tipoVista: [this.RB_TIPO_VENDEDOR, [Validators.required]],
      Tiponc: [null],
      motivodev: [null],
      unidadneg: [null]
    });
  }

  private loadComboTipoNotaCredito() {
    // Tipos documentos
    const inputParams = {
      entidad:{
        codigo: 0 //TODO: VALOR QUE NO SE VISUALIZARA EN NOTA DE VENTA
      }
    }

    this.log('inputParams', JSON.stringify(inputParams))

    // this.tipoNCNDService.GetSegunTipoNCND(this.dataCabecera.cabecera.tipo_ncnd_codigo, 1, ({ respuesta }) => {
    this.tipoNCNDService.GetNotaCreditoTipo(inputParams, ({ respuesta }) => {
      const { registros } = respuesta
      this.optionsTipoNota = registros.map(tipo => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }))
    })
  }

  private loadMotivoDevolucionGeneral() {
    // Tipos documentos
    this.motivoDevolucionService.GetMotivoDevolucionGeneral(this.rutEmpresa, this.sucursalCodigo, ({ respuesta }) => {
      const { registros } = respuesta
      this.optionsMotivoDev = registros.map(tipo => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }))
    })
  }


  private loadUnidadNegocio() {
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        tipo: -1
      }
    }
    this.optionsUnidNegocio = []
    this.unidadNegocioService.obtenerUnidadNegocio(inputParams, ({ respuesta }) => {
      const { registros } = respuesta

      this.optionsUnidNegocio = registros.map(unidad_negocio => ({
        value: unidad_negocio.codigo,
        label: unidad_negocio.nombre
      }));

      // this.optionsUnidNegocio.unshift({
      //   value: 0,
      //   label: "Todos"
      // });

      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('unidadneg'), this.optionsUnidNegocio)
    })
  }

  //ABRIR MODAL SELECCION VENDEDOR O CLIENTE
  abrirModalSeleccion() {
    if (this.formHeader.get('tipoVista').value === this.RB_TIPO_CLIENTE)
      this.abrirModalSeleccionarCliente()
    else if (this.formHeader.get('tipoVista').value === this.RB_TIPO_VENDEDOR)
      this.abrirModalSeleccionarVendedor()
  }

  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show();
  }

  abrirModalSeleccionarVendedor() {
    this.modalSeleccionarVendedor.show();
  }


  onClienteSeleccionado({ data, origen }) {
    this.limpiarDataSeleccionada()
    console.log("CLIENTE : ",data)
    this.clientesSeleccionados = data;
  }

  onClienteNoEncontrado() {
     this.clientesSeleccionados = null;
  }


  limpiarDataSeleccionada() {
    this.clientesSeleccionados = null
    this.VendedorSeleccionado = null
  }

  limpiarBuscarPorCliente() {
    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null
  }

  //FUNCIONES DE VENDEDOR

  onVendedorSeleccionado({ data }) {
    this.limpiarDataSeleccionada();
    console.log("VENDEDOR : ",data)
    this.VendedorSeleccionado = data
  }

  onVendedorNoEncontrado() {
    this.VendedorSeleccionado = null
  }

  limpiarBuscarVendedor(){
        // this.clienteSeleccionado = null
    this.VendedorSeleccionado = null
  }

  limpiarfiltros() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader.reset();
    this.formHeader.get('tipoVista').setValue(this.RB_TIPO_VENDEDOR);
    this.formHeader.get('fechaDesde').setValue(initDate);
    this.formHeader.get('fechaHasta').setValue(currentDate);

    this.VendedorSeleccionado = null;
    this.clientesSeleccionados = null;
  }

  //BUSCAR
  buscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.paginationContext.CurrentPage = pageNumber

    this.listaMovimientos = []
    this.listaMovimientosAll = []

    const { fechaDesde, fechaHasta,  motivodev, Tiponc, unidadneg } = this.formHeader.value

    var rut = 0;
    if(this.VendedorSeleccionado == null){
      rut = 0;
    }else{
      if(this.VendedorSeleccionado && this.clientesSeleccionados == null){
        rut = this.VendedorSeleccionado.rut
      }

      if(this.clientesSeleccionados && this.VendedorSeleccionado == null){
        rut = this.clientesSeleccionados.rut
      }
    }

    const inputParams = {
      filtro: {
        exacto:
        {
          tipo_dte_codigo: 61,
          fecha_desde: fechaDesde,
          fecha_hasta: fechaHasta,
          unidad_negocio: unidadneg == null ? 0 : unidadneg,
          cliente_proveedor_rut: this.clientesSeleccionados ? this.clientesSeleccionados.rut : 0,
          vendedor_rut: this.VendedorSeleccionado ? this.VendedorSeleccionado.rut : 0,
          tipo_ncnd: Tiponc,
          motivo_dev_codigo: motivodev
        }
      },
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1 //this.paginationContext.RecordsByPage
    }

    this.currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.tipoNCNDService.obtenerSegunFiltroReporteNotaCredito(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros } = respuesta

      this.listaMovimientosAll = registros
      console.log(registros);
      this.TotalNC = this.listaMovimientosAll.length;
      this.Totalmonto = _.sumBy(this.listaMovimientosAll, 'monto'),

      this.paginationContext.RecordsCount = this.listaMovimientosAll.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      // this.paginationContext.CurrentPage = 1

      this.listaMovimientosAll.forEach(mov => {
        mov.rutFormato = this.rutService.AgregarDV(mov.rut_cliente)
      })

      this.showPage(this.paginationContext.CurrentPage)
      this.loading = false
    })
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.filtro.exacto.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.tipoNCNDService.obtenerSegunFiltroReporteNotaCreditoExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

}
